import { render, staticRenderFns } from "./xskSku.vue?vue&type=template&id=b557f5ca&scoped=true"
import script from "./xskSku.vue?vue&type=script&lang=js"
export * from "./xskSku.vue?vue&type=script&lang=js"
import style0 from "./xskSku.vue?vue&type=style&index=0&id=b557f5ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b557f5ca",
  null
  
)

export default component.exports